// Materials
export const SUPER_KNIT = 'superknit';
export const HYDRO_KNIT = 'hydroknit';
export const SUPER_KNIT_LUXE = 'superknit-luxe';
export const SPORT_FLEX = 'sportflex';

// Product type
export const WRIST_BAND = 'wrist-band';
export const WYW_PRODUCT_TYPE = 'whoop-your-way';
